export default __webpack_public_path__ + "static/media/Arm_right.89b0331b.svg";